
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rebuild-directory",
      function () {
        return require("private-next-pages/rebuild-directory.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rebuild-directory"])
      });
    }
  